// /bids/new — "Who are we bidding?" then straight on to the building.

import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../../shared/components';
import { fetchAccounts, fetchMarkets, fetchParents, type Option } from './api';
import { Section } from './fields';
import { StartForm } from './start-form';
import { useBidLoad } from './use-bid-load';

export default function BidNew() {
  const nav = useNavigate();
  const { data } = useBidLoad<{ markets: Option[]; parents: Option[]; accounts: Option[] }>(
    async () => {
      const [markets, parents, accounts] = await Promise.all([fetchMarkets(), fetchParents(), fetchAccounts()]);
      return { markets, parents, accounts };
    },
    [],
    { markets: [], parents: [], accounts: [] },
  );
  return (
    <div className="mx-auto max-w-4xl space-y-5 p-4 sm:p-6">
      <PageHeader eyebrow="Bids › New bid" title="Start a bid" meta="After the walkthrough. The kind of building decides the questions that come next." />
      <Section title="Who are we bidding?">
        <StartForm bid={null} {...data} onSaved={(b) => nav(`/bids/${b.bid_id}?step=building`)} />
      </Section>
    </div>
  );
}
